






import StaffFranchiseListPage from './StaffUserManager.vue';
import Vue from 'vue';
export default Vue.extend({
  components: {
    StaffFranchiseListPage,
  },
});
